import React from 'react';
import { LucideIcon } from 'lucide-react';

interface PageHeroStat {
  label: string;
  value: React.ReactNode;
}

interface PageHeroProps {
  eyebrow: string;
  title: string;
  description: string;
  icon: LucideIcon;
  accent?: string;
  stats?: PageHeroStat[];
  actions?: React.ReactNode;
  children?: React.ReactNode;
}

export const PageHero: React.FC<PageHeroProps> = ({
  eyebrow,
  title,
  description,
  icon: Icon,
  accent = 'var(--f1-red)',
  stats = [],
  actions,
  children,
}) => (
  <section className="sdc-page-hero relative overflow-hidden" style={{ '--page-accent': accent } as React.CSSProperties}>
    <div className="sdc-page-hero-grid" />
    <div className="sdc-page-hero-glow" />
    <Icon className="sdc-page-hero-watermark" aria-hidden="true" />
    <div className="sdc-page-hero-accent" />
    <div className="relative z-10 grid gap-4 lg:grid-cols-[minmax(0,1fr)_auto] lg:items-center">
      <div className="flex min-w-0 items-start gap-4">
        <span className="sdc-page-hero-icon" style={{ color: accent }}><Icon size={22} /></span>
        <div className="min-w-0 max-w-3xl">
          <span className="sdc-page-hero-eyebrow">{eyebrow}</span>
          <h1 className="sdc-display sdc-page-hero-title">{title}</h1>
          <p className="sdc-page-hero-description">{description}</p>
          {children}
        </div>
      </div>

      {(stats.length > 0 || actions) && (
        <div className="flex flex-wrap items-center gap-2 lg:justify-end">
          {stats.map(stat => (
            <div key={stat.label} className="sdc-page-hero-stat">
              <div className="sdc-page-hero-stat-value">{stat.value}</div>
              <div className="sdc-page-hero-stat-label">{stat.label}</div>
            </div>
          ))}
          {actions && <div className="flex items-center gap-2 lg:pl-1">{actions}</div>}
        </div>
      )}
    </div>
  </section>
);
